import React from "react";
import MegaHeader from "../components/MegaHeader/MegaHeader";
import Footer from "../components/footer/Footer";
import HirePageBanner from "../components/HirePageBanner/HirePageBanner";
import UnderStandEngagmentModel from "../components/UnderstandEngagmentModel/UnderStandEngagmentModel";
import EngagmentModelScroller from "../components/engagment-model-scroller/EngagmentModelScroller";
import ContactSection from "../components/contactSection/ContactSection";
import { mainBannerImg } from "../data/engagement-model-data";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import SoftwareCompanyCta from "../components/software-company-cta/SoftwareCompanyCta";
import MegaMenu from "../components/MegaMenu/MegaMenu";
import EngagementModelTable from "../components/engagement-models-table/EngagementModelTable";
import ServicesPageBanner from "../components/services-page-banner/ServicesPageBanner";
import NewTestimonials from "../components/new-testimonials/NewTestimonials";
import NewCaseStudySection from "../components/new-case-study-section/NewCaseStudySection";
import NewRoadMap from "../components/new-raodmap-section/NewRoadMap";

const EngagmentModel = () => {

  const { t: tmetaTitles } = useTranslation("metaTitles");
  const metaTitle = tmetaTitles("engagementModelPageTitle", {
    returnObjects: false,
  });

  const companyCta = {
    heading: "Talk to us & get your project moving!",
    // subHeading: "See how our expert developers can help.",
    buttonText: "Discuss Project Needs",
  }


  const roadmapContent = {
    shortHeading: "AI & Software Development Roadmap",
    heading: "Getting started with <span>Software & AI development</span> services is simple & painless.",
    description:
      "Within a month, you can see your idea start to come to life.",
    processData: [
      {
        title: "Discovery",
        description: "Through a focused series of discovery workshops lasting one day to a week, our team understands your vision & gathers insights to design a clear, agile AI software roadmap.",
        icon: "/images/roadmap-icons/Discovery.svg"
      },
      {
        title: "Choose Engagement Model for Team Structure",
        description: "We quickly align on a suitable customer engagement model, determine the precise skills required, & design an efficient team structure, ensuring your project runs smoothly & meets all business objectives effectively.",
        icon: "/images/roadmap-icons/development-strategy.svg"
      },
      {
        title: "Deployment",
        description: "Our deployment process utilizes CI/CD pipelines & automated scripts to ensure a consistent, zero-downtime transition to production environments.",
        icon: "/images/roadmap-icons/Development.svg"
      }
    ],
    cta: {
      text: "Let's Make It",
      link: "/contact-us"
    }
  }

  const engagementModelsContent = {
    sectionHeading: "Engagement Model Comparison",
    subHeading: "Comparison at a Glance",
    description:
      "To make a short & simple comparison, let’s put all the significant features of the discussed engagement models together.",

    tableHead: ["Engagement Model", "Best Suited For", "Key Advantages"],

    tableData: [
      {
        textOne: "BOT",
        textTwo: "SMB setting up offshore operations",
        textThree: "Full ownership transfer, risk free expansion",
      },
      {
        textOne: "Dedicated Teams",
        textTwo: "Long term projects & enterprise growth",
        textThree: "Domain expertise, transparency, scalability",
      },
      {
        textOne: "Flexible Model",
        textTwo: "Short term skills & agile scaling",
        textThree: "Rapid onboarding, flexibility, cost efficiency",
      },
      {
        textOne: "Fixed Price",
        textTwo: "Well defined projects with strict timelines",
        textThree: "Predictable outcomes, budget certainty",
      },
      {
        textOne: "White Label",
        textTwo: "Agencies/resellers scaling offerings",
        textThree: "Confidential growth, faster time to market",
      },
    ],

    noteText:
      "We offer a 100% money back guarantee with a no questions asked refund policy, ensuring complete confidence & risk free engagement.",
  };

  return (
    <>
      <Helmet>
        <title>Flexible IT Engagement Models & Partnerships | Bitsclan</title>
        <meta
          name="description"
          content="Explore flexible IT engagement models & partnerships with Bitsclan. From software to AI development, choose the right model based on project size, strategy and goals."
        />
      </Helmet>
      <MegaMenu />
      {/* <HirePageBanner
        diffBannerBackgroundImage={mainBannerImg?.backgroundImage}
        mainHeading={heading}
        greenHeading={greenHeading}
        content={content}
        btnText={buttonText}
        bannerList={bannerList}
        btnLink={"/contact-us"}
        hideIcon={false}
        newTab={false}
      /> */}
      <ServicesPageBanner shortHeading="How We Partner"
        mainHeading="Flexible Engagement Models Tailored to Your Business"
        description="We design, deliver, & manage IT solutions in ways that suit your business best. With flexible engagement models, we support every software, mobile app, & AI development project with efficiency & reliability." />
      {/* <UnderStandEngagmentModel /> */}
      <EngagmentModelScroller />
      <EngagementModelTable content={engagementModelsContent} />
      {/* <ContactSection /> */}
      <NewRoadMap roadmapContent={roadmapContent} />
      {/* <NewTestimonials
        shortHeading="Our Client Relationships go Beyond"
        mainHeading="Testimonials"
        description="Our client relationships extend beyond delivery. Explore authentic reviews that reflect trust, collaboration, & results, showing how we consistently support businesses with lasting value & dependable AI & software development services." /> */}
      <NewCaseStudySection
        shortHeading="Some of our successful Engagements"
        heading="Success Stories"
        description="Check out Bitsclan’s successful engagements featuring real client successes. Our case studies highlight proven strategies, cutting edge AI & software solutions, & metrics to create successful outcomes for businesses."
      />
      <SoftwareCompanyCta content={companyCta} />
      <Footer />
    </>
  );
};

export default EngagmentModel;
